<template>
    <vs-row>
      <vs-col vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
        <Form :isRRHH=isRRHH />
      </vs-col>
    </vs-row>
</template>
<script>
import Form from '../components/Form'

export default {
    props: ['isRRHH'],
    data(){
        return {
            tooltip: 'col - 4'
        }
    },
    components: {
        Form
    }
}
</script>